import React, { useState, useContext, useEffect } from "react";
import { AuthContext } from "../contextApi/useAuth"; // Adjust path as needed
import { ToastContainer, toast } from 'react-toastify'; 
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { Link, Navigate, useNavigate } from "react-router-dom";

function LoginPage() {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const { login } = useContext(AuthContext); // Get the login function
  const navigate = useNavigate();

  // Check if the user is already logged in
  useEffect(() => {
    const token = window.sessionStorage.getItem('token');
    if (token) {
      // Redirect to dashboard if token is found
      navigate("/dashboard");
    }
  }, [navigate]);

  const changeHandler = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const submitHandler = async (event) => {
    event.preventDefault();
    
    const result = await login(formData.email, formData.password);

    if (result.success) {
      if (result.token) {
        window.sessionStorage.setItem('token', result.token);
        navigate("/dashboard");  // Redirect to dashboard on successful login
      } else {
        navigate("/");  // If no token, redirect to the homepage
      }
    }
  };

  const token = window.sessionStorage.getItem('token');
  if (token) {
    return null; 
  }

  return (
    <div className="flex items-center justify-center min-h-screen py-8 px-4 h-full " style={{ backgroundImage: 'url(assits/Login.png)', backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}>
      <div className="w-[800px] max-w-4xl flex justify-between items-center p-8 rounded-lg space-y-6 shadow-lg bg-white">
        {/* Image Section */}
        <div className="flex justify-center mb-6">
          <img src="assits\6.png" alt="Logo" className="max-w-xs" />
        </div>
        <div className="w-[46%]">
          <img src="/assits/logo.png" />
          <h2 className="text-green-700 font-bold text-2xl mb-5">HIIMS Portal Sign In</h2>
          {/* Form Section */}
          <form onSubmit={submitHandler} className="space-y-6">
            {/* Email Address Input */}
            <label className="w-full">
              <p className="text-[18px] text-richblack-100 mb-4 leading-tight text-black">
                Email Address <sup className=" text-red-600 text-xl">*</sup>
              </p>
              <input
                required
                type="email"
                value={formData.email}
                onChange={changeHandler}
                placeholder="Enter Your Email"
                name="email"
                className="bg-richblack-700 text-richblack-5 rounded-md w-full p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 border-2 border-ring-blue-500 mb-3"
              />
            </label>
            
            {/* Password Input */}
            <label className="w-full relative">
              <p className="text-sm text-richblack-100 mb-2 leading-tight text-black text-[18px]">
                Password <sup className="text-red-600 ">*</sup>
              </p>
              <input
                required
                type={showPassword ? "text" : "password"}
                value={formData.password}
                onChange={changeHandler}
                placeholder="Enter Your Password"
                name="password"
                className="bg-richblack-700 text-richblack-5 rounded-md w-full p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 border-2"
              />
              {/* Toggle Show/Hide Password */}
              <span
                className="absolute right-3 top-[77%] cursor-pointer"
                onClick={() => setShowPassword((prev) => !prev)}
              >
                {showPassword ? (
                  <AiOutlineEyeInvisible fontSize={24} fill="#AFB2BF" />
                ) : (
                  <AiOutlineEye fontSize={24} fill="#AFB2BF" />
                )}
              </span>
            </label>

            {/* Submit Button */}
            <button
              type="submit"
              className="bg-green-700 text-richblack-900 font-medium rounded-md w-full py-3 mt-6 hover:bg-green-400 focus:outline-none focus:ring-2 focus:ring-yellow-500"
            >
              Sign In
            </button>
          </form>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
}

export default LoginPage;
